<template>
  <div class="login-card__register-email-card">
    <div class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.welcome.header') }}</h1>
    </div>

    <p class="register-email-card__chosed-genders">
      {{ trans.get('auth.card.register.email.gender') }}
      {{ trans.get('common.pre_' + this.form.gender) }}

      <span class="chosed-genders__text-color"> {{ trans.get('common.' + this.form.gender + '_official') }}</span>

      {{ trans.get('auth.card.register.email.preferred_gender') }}

      <span v-html="preferredGender"></span>
    </p>

    <a @click="checkAgreementGoogle" :href="zRoute('login.provider', 'google')" class="button button--google">
      <img src="../../../images/logo/google.svg" alt="Google button">
      {{ trans.get('auth.card.welcome.google_button') }}
    </a>

    <a @click="checkAgreementFacebook" class="button button--fb">
      <i class="demo-icon icon-facebook-circle"> </i>
      {{ trans.get('auth.card.welcome.facebook_button') }}
    </a>

    <p class="register-email-card__chosed-genders">
      {{ trans.get('auth.card.welcome.or') }}
    </p>

    <div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-group">
            <validation-provider name="email" rules="required" v-slot="{ errors }" mode="eager">
              <label for="email"></label>
              <input
                type="email" id="email" class="input-text__underline input-text--shadow" v-model="form.email"
                placeholder="User@example.com"
              >
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="form-group">
            <validation-provider name="password" rules="required" v-slot="{ errors }" mode="eager">
              <div class="input-group is-invalid">
                <label for="password"></label>
                <div class="input-group-append">
                  <input
                    :type="passwordInputType" id="password"
                    class="form-control input-text input-text__underline input-text--shadow" v-model="form.password"
                    :placeholder="trans.get('auth.card.fields.password')"
                  >
                  <button
                    type="button" class="button__password-eye"
                    @click="switchPasswordVisibility"
                  >
                    <i class="demo-icon icon-show" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
            <div class="agreement d-flex mt-3 mb-3 checkbox-standard text-left">
              <label for="agreement" class="login-card__title-desc login-card__title-desc--small">
                <input type="checkbox" id="agreement" v-model="form.agreement" required>


                <span class="checkbox-standard__box checkbox-standard__box--small checkbox-standard__box--purple mr-2"></span>


                <span
                  id="checkAgreement"
                  v-html="trans.get('auth.card.registration_agreement', { link1: zRoute('page.agb'), link2: zRoute('page.privacy'), link3: zRoute('page.terms') })"
                ></span>
              </label>
            </div>
          </div>

          <button type="submit" @click="checkAgreement" class="button__auth">
            {{ trans.get('auth.card.buttons.free_registration') }}
            <img src="../../../images/registration/arrow-right.svg" class="registration-button-arrow" />
          </button>
        </form>
      </validation-observer>
    </div>

    <button class="login-card__link" @click="swapComponent('auth-login-card')">
      {{ trans.get('auth.card.welcome.member_already') }}
      <span>{{ trans.get('auth.card.welcome.log_in') }}</span>
    </button>

    <button type="button" class="button button__link button--back" @click="swapComponent('auth-welcome-card')">
      <i class="demo-icon icon-left"> </i>
      {{ trans.get('auth.card.buttons.back') }}
    </button>
  </div>
</template>
<script>
import AuthGoBackMixin from './../../../../js/front/components/Auth/AuthGoBackMixin';

export default {
  props: ['swapComponent', 'form'],
  mixins: [AuthGoBackMixin],
  data: () => ({
    passwordInputType: 'password',
  }),
  mounted() {
    //TODO do weryfikacji aran
    window.localStorage.setItem('gender', this.form.gender);
    window.localStorage.setItem('preferred_gender', JSON.stringify(this.form.preferred_gender));
  },
  methods: {
    switchPasswordVisibility() {
      this.passwordInputType = this.passwordInputType === 'password' ? 'text' : 'password';
    },
    onSubmit() {
      const self = this;
      axios.post(zRoute('register'), {
        email: this.form.email,
        password: this.form.password,
        cid: window.localStorage.getItem('campaign_cid'),
        eid: window.localStorage.getItem('campaign_eid'),
        campaign_query: window.localStorage.getItem('campaign_query'),
        gender: this.form.gender,
        preferred_gender: this.form.preferred_gender,
      }).then(function (response) {
        if (response.data.status === 'success') {
          // if (window.globals.settings_verification_required) {
          if (response.data.verification_is_required) {
            self.swapComponent('auth-verification-email-card');
          } else {
            self.swapComponent('auth-name-card');
          }
        }
      }, function (error) {
        if (error.response.status === 422) {
          if (!('email' in error.response.data.errors || 'password' in error.response.data.errors)) {

            self.$refs.form.setErrors({ 'email': error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] });
          } else {
            self.$refs.form.setErrors(error.response.data.errors);
          }
        }
      });
    },
    checkAgreement() {
      let agreementText = document.querySelector('#checkAgreement');
      let agreementTextChilds = agreementText.children;
      if (!this.form.agreement) {
        agreementText.style.color = 'red';
        for (let i = 0; i < agreementTextChilds.length; i++) {
          agreementTextChilds[i].style.color = 'red';
        }
      } else {
        agreementText.style.color = 'black';
        for (let i = 0; i < agreementTextChilds.length; i++) {
          agreementTextChilds[i].style.color = 'black';
        }
      }
    },
    checkAgreementFacebook() {
      let agreementText = document.querySelector('#checkAgreement');
      let agreementTextChilds = agreementText.children;
      if (!this.form.agreement) {
        agreementText.style.color = 'red';
        for (let i = 0; i < agreementTextChilds.length; i++) {
          agreementTextChilds[i].style.color = 'red';
        }
      } else {
        agreementText.style.color = 'black';
        for (let i = 0; i < agreementTextChilds.length; i++) {
          agreementTextChilds[i].style.color = 'black';
        }
        window.location.href = zRoute('login.provider', 'facebook');
      }
    },
    checkAgreementGoogle() {
      let agreementText = document.querySelector('#checkAgreement');
      let agreementTextChilds = agreementText.children;
      if (!this.form.agreement) {
        agreementText.style.color = 'red';
        for (let i = 0; i < agreementTextChilds.length; i++) {
          agreementTextChilds[i].style.color = 'red';
        }
      } else {
        agreementText.style.color = 'black';
        for (let i = 0; i < agreementTextChilds.length; i++) {
          agreementTextChilds[i].style.color = 'black';
        }
        window.location.href = zRoute('login.provider', 'google');
      }
    },
    goBack() {
      this.swapComponent('auth-welcome-card');
    }
  },
  computed: {
    preferredGender: function () {
      let preferredGender = this.form.preferred_gender.sort();
      let pre = this.trans.get('common.pre2_male');
      if (preferredGender[0] === 'female') {
        pre = this.trans.get('common.pre2_female');
      }

      return pre + ' <span class="chosed-genders__text-color">' + (preferredGender.length === 1 ? this.trans.get('common.' + preferredGender[0] + '_official') : this.trans.get('common.' + preferredGender[0] + '_official') + '&' + this.trans.get('common.' + preferredGender[1] + '_official')) + '</span>';
    }
  }
};
</script>
<style scoped>

</style>